import { get } from 'lodash';

export interface IKeyboardEventItem {
  [key: string]: any;
}

export interface IKeyboardEvent_GridTraversalItem extends IKeyboardEventItem {
  direction: string;
  keyCodes: string[];
}

export interface IKeyboardEvent_CarouselItem extends IKeyboardEventItem {
  direction: string;
  keyCodes: string[];
}

export interface IKeyboardEventMap {
  gameboard: IKeyboardEvent_GridTraversalItem[];
  carousel?: IKeyboardEvent_CarouselItem[];
}

export const keyboardEventMap: IKeyboardEventMap = {
  gameboard: [
    {
      direction: 'UP',
      keyCodes: ['ArrowUp', 'KeyW'],
    },
    {
      direction: 'RIGHT',
      keyCodes: ['ArrowRight', 'KeyD'],
    },
    {
      direction: 'DOWN',
      keyCodes: ['ArrowDown', 'KeyS'],
    },
    {
      direction: 'LEFT',
      keyCodes: ['ArrowLeft', 'KeyA'],
    },
  ],
};

export type GetKeyboardEventMapItemProps = {
  // keyCode: string;
  mapPath: keyof IKeyboardEventMap;
  event: KeyboardEvent;
  callback?: () => void;
};

export const getKeyboardEventMapItem = (
  props: GetKeyboardEventMapItemProps
) => {
  console.log(props);
  const { event, mapPath } = props;
  const keyCodeNode: IKeyboardEventMap[typeof mapPath] | undefined = get(
    keyboardEventMap,
    mapPath
  );
  if (!keyCodeNode) return false;
  const keyCodeItem = keyCodeNode.find(
    (item: any) => item.keyCodes.indexOf(event.code) !== -1
  );
  return keyCodeItem || false;
};
